import { EEirSalesNLEStatus } from "@modules/eirSalesFacade/constants";
import { IEirSalesNle } from "@modules/eirSalesFacade/interfaces/models/IEirSalesNLE";
import { IEirSalesNleResponse } from "@modules/eirSalesFacade/interfaces/responses/IEirSalesNLEResponse";

export const mapEirSalesNLEResponse = (response: IEirSalesNleResponse): IEirSalesNle => ({
    activeFthPathsQuantity: response.activeFthPathsQuantity,
    activePathsQuantity: response.activePathsQuantity,
    activePathsQuantityNo: response.activePathsQuantityNo,
    spareFthPathsQuantity: response.spareFthPathsQuantity,
    spareFthPathsQuantityOnt: response.spareFthPathsQuantityOnt,
    spareFthPathsQuantityOntOn: response.spareFthPathsQuantityOntOn,
    sparePathsQuantity: response.sparePathsQuantity,
    sparePathsQuantityNo: response.sparePathsQuantityNo,
    status: response.status as EEirSalesNLEStatus,
});
